import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { SmartText } from '../../common/SmartText';
import { InlineDateTimePicker } from 'material-ui-pickers';

import { MODES } from '../AssignmentsContentPanel/assignmentsContentPanelService';
import DateBoxContainer from './DateBoxContainer/DateBoxContainer';
import { isAfter } from '../../../utils/dateUtlis';
import dayjs from 'dayjs';

class DatesContainer extends Component {
  render() {
    const {
      startDate,
      deadLine,
      selectDeadLine,
      selectStartDate,
      locale,
      mode,
      setDatesContainerInteraction,
      datesContainerState,
      disabledStartDate
    } = this.props;
    const invalidDeadLine = isAfter(startDate, deadLine, 'seconds');
    const invalidStartDate = !disabledStartDate && isAfter(datesContainerState.currentDate, startDate, 'seconds');

    return (
      <div className="date-selector-container">
        <SmartText fontSize="18px" fontFamily="LatoSemibold" color="#333" style={{ marginBottom: '25px' }}>
          {I18n.t('panels.discussion.dueDate')}
        </SmartText>
        <div className="date-selector-row-layout">
          <DateBoxContainer dueDate={deadLine} locale={locale} />
          <div className="dates-labels-content">
            <div className="dates-error">{invalidDeadLine && I18n.t('panels.errors.dates.minDueDate')}</div>
            <div className="dates-error">{invalidStartDate && I18n.t('panels.errors.dates.minStartDate')}</div>
            <div className="wrapper-date-time-pickers">
              <div className="date-timepicker-wrapper">
                <InlineDateTimePicker
                  disabled={disabledStartDate}
                  ampm={false}
                  onOpen={setDatesContainerInteraction}
                  autoOk
                  maxDate={deadLine}
                  {...(mode === MODES.EDIT && !datesContainerState.hasInteraction ? '' : { disablePast: true })}
                  value={startDate}
                  format={'DD/MM/YYYY HH:mm'}
                  onChange={selectStartDate}
                  label={I18n.t('panels.common.selectStartDate')}
                  minDateMessage={''}
                />
              </div>
              <div className="date-timepicker-wrapper">
                <InlineDateTimePicker
                  ampm={false}
                  autoOk
                  minDate={startDate}
                  value={deadLine}
                  format={'DD/MM/YYYY HH:mm'}
                  onChange={selectDeadLine}
                  label={I18n.t('panels.common.selectEndDate')}
                  minDateMessage={''}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DatesContainer;

DatesContainer.propTypes = {
  locale: PropTypes.string,
  mode: PropTypes.string,
  startDate: PropTypes.object,
  selectStartDate: PropTypes.func,
  deadLine: PropTypes.object,
  selectDeadLine: PropTypes.func,
  setDatesContainerInteraction: PropTypes.func,
  datesContainerState: PropTypes.object,
  disabledStartDate: PropTypes.bool
};
